import isNumber from 'lodash-es/isNumber';
import { snakeCase } from 'snake-case';
import isObject from 'lodash-es/isObject';
import { useEffect, isValidElement } from 'react';
import _regeneratorRuntime from '@babel/runtime/helpers/regeneratorRuntime';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import ReactIs from 'react-is';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import isString from 'lodash-es/isString';
import { pascalCase, kebabCase, snakeCase as snakeCase$1 } from 'change-case';
export { kebabCase as dashCase, pascalCase, snakeCase } from 'change-case';
import isArray from 'lodash-es/isArray';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import get from 'lodash-es/get';
import capitalize from 'lodash-es/capitalize';
import EventEmitter from 'wolfy87-eventemitter';
import slugify from 'slugify';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import uniqBy from 'lodash-es/uniqBy';

function checkClickable(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parentDistance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var _ref = options || {},
    _ref$maxParentDistanc = _ref.maxParentDistance,
    maxParentDistance = _ref$maxParentDistanc === void 0 ? 5 : _ref$maxParentDistanc,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? ['BUTTON', 'A', 'INPUT', 'I', 'TEXTAREA'] : _ref$tags;
  var _ref2 = el || {},
    _ref2$tagName = _ref2.tagName,
    tagName = _ref2$tagName === void 0 ? null : _ref2$tagName,
    _ref2$parentNode = _ref2.parentNode,
    parentNode = _ref2$parentNode === void 0 ? null : _ref2$parentNode;
    _ref2.dataset;
  if (tagName === 'BODY') {
    return false;
  }

  // Check if video is suspended
  // if (
  //     tagName === 'VIDEO' &&
  //     typeof dataset.isSuspended !== 'undefined' &&
  //     (dataset.isSuspended === 'true' || dataset.isSuspended === true)
  // ) {
  //     return true;
  // }

  if (tags.map(function (it) {
    return it.toLowerCase();
  }).indexOf(tagName.toLowerCase()) !== -1) {
    return true;
  }
  if (parentDistance < maxParentDistance) {
    return checkClickable(parentNode, options, parentDistance + 1);
  }
  return false;
}

var convertStyleToString = function convertStyleToString(style) {
  return style !== null ? Object.keys(style).map(function (key) {
    return "".concat(snakeCase(key), ":").concat(isNumber(style[key]) ? "".concat(style[key], "px") : style[key], ";");
  }).join('\n') : '';
};

var createNullableOnChange = function createNullableOnChange() {
  var onChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (newValue) {
    var nullableValue = newValue;
    if (isObject(newValue)) {
      var allNull = Object.keys(newValue).reduce(function (acc, key) {
        return acc && newValue[key] === null;
      }, true);
      if (allNull) {
        nullableValue = null;
      }
    }
    if (onChange !== null) {
      onChange(nullableValue);
    }
  };
};

var createUseEvent = function createUseEvent(eventsManager) {
  return function (event, callback) {
    var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    useEffect(function () {
      if (enabled && eventsManager !== null) {
        eventsManager.subscribe(event, callback);
      }
      return function () {
        if (enabled && eventsManager !== null) {
          eventsManager.unsubscribe(event, callback);
        }
      };
    }, [eventsManager, event, callback, enabled]);
  };
};

/*! clipboard-copy. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */

// @note vendoring this: https://github.com/feross/clipboard-copy/blob/master/index.js
// we might want to add that to the npm deps and just use it

function makeError() {
  return new DOMException('The request is not allowed', 'NotAllowedError');
}
function copyClipboardApi(_x) {
  return _copyClipboardApi.apply(this, arguments);
}
function _copyClipboardApi() {
  _copyClipboardApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(text) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (navigator.clipboard) {
            _context.next = 2;
            break;
          }
          throw makeError();
        case 2:
          return _context.abrupt("return", navigator.clipboard.writeText(text));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _copyClipboardApi.apply(this, arguments);
}
function copyExecCommand(_x2) {
  return _copyExecCommand.apply(this, arguments);
}
function _copyExecCommand() {
  _copyExecCommand = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(text) {
    var span, selection, range, success;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          // Put the text to copy into a <span>
          span = document.createElement('span');
          span.textContent = text;

          // Preserve consecutive spaces and newlines
          span.style.whiteSpace = 'pre';
          span.style.webkitUserSelect = 'auto';
          span.style.userSelect = 'all';

          // Add the <span> to the page
          document.body.appendChild(span);

          // Make a selection object representing the range of text selected by the user
          selection = window.getSelection();
          range = window.document.createRange();
          selection.removeAllRanges();
          range.selectNode(span);
          selection.addRange(range);

          // Copy text to the clipboard
          success = false;
          try {
            success = window.document.execCommand('copy');
          } finally {
            // Cleanup
            selection.removeAllRanges();
            window.document.body.removeChild(span);
          }
          if (success) {
            _context2.next = 15;
            break;
          }
          throw makeError();
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _copyExecCommand.apply(this, arguments);
}
function copyToClipboard(_x3) {
  return _copyToClipboard.apply(this, arguments);
}
function _copyToClipboard() {
  _copyToClipboard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(text) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return copyClipboardApi(text);
        case 3:
          _context3.next = 15;
          break;
        case 5:
          _context3.prev = 5;
          _context3.t0 = _context3["catch"](0);
          _context3.prev = 7;
          _context3.next = 10;
          return copyExecCommand(text);
        case 10:
          _context3.next = 15;
          break;
        case 12:
          _context3.prev = 12;
          _context3.t1 = _context3["catch"](7);
          throw _context3.t1 || _context3.t0 || makeError();
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 5], [7, 12]]);
  }));
  return _copyToClipboard.apply(this, arguments);
}

var _flattenComponents = function flattenComponents(components) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (components === null) {
    return null;
  }
  return Object.keys(components).reduce(function (newMap, key) {
    return ReactIs.isValidElementType(components[key]) ? _objectSpread(_objectSpread({}, newMap), {}, _defineProperty({}, prefix !== null ? "".concat(prefix, ".").concat(key) : key, components[key])) : _objectSpread(_objectSpread({}, newMap), _flattenComponents(components[key], key));
  }, {});
};

var formatDuration = function formatDuration(timeInSeconds) {
  var numberOfSeconds = parseInt(timeInSeconds, 10); // don't forget the second param
  var hours = Math.floor(numberOfSeconds / 3600);
  var minutes = Math.floor((numberOfSeconds - hours * 3600) / 60);
  var seconds = numberOfSeconds - hours * 3600 - minutes * 60;
  if (hours < 10) {
    hours = "0".concat(hours);
  }
  if (minutes < 10) {
    minutes = "0".concat(minutes);
  }
  if (seconds < 10) {
    seconds = "0".concat(seconds);
  }
  return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
};

var _excluded$1 = ["component"];
var getComponent = function getComponent(component) {
  var _ref = isObject(component) ? component : {
      component: component
    };
    _ref.component;
    var props = _objectWithoutProperties(_ref, _excluded$1);
  return {
    name: component,
    props: props
  };
};

var _excluded = ["id", "field"];
var getColumnFromField = function getColumnFromField(field) {
  if (field === null) {
    return null;
  }
  // eslint-disable-next-line camelcase
  var name = field.name,
    _field$components = field.components,
    _field$components2 = _field$components === void 0 ? {} : _field$components,
    _field$components2$di = _field$components2.display,
    display = _field$components2$di === void 0 ? null : _field$components2$di,
    label = field.label;
  var _getComponent = getComponent(display),
    _getComponent$name = _getComponent.name,
    componentName = _getComponent$name === void 0 ? null : _getComponent$name,
    _getComponent$props = _getComponent.props,
    componentProps = _getComponent$props === void 0 ? null : _getComponent$props;
  return _objectSpread(_objectSpread({}, componentProps), {}, {
    id: name,
    label: label,
    valueKey: name,
    component: componentName,
    field: field
  });
};
var getColumnsWithFields = function getColumnsWithFields(resource, columns) {
  var fields = resource.fields;
  var newColumns = columns !== null ? columns.map(function (column) {
    var _ref = isString(column) ? {
        field: column
      } : column,
      _ref$id = _ref.id,
      colId = _ref$id === void 0 ? null : _ref$id,
      _ref$field = _ref.field,
      colField = _ref$field === void 0 ? null : _ref$field,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    var fieldName = colField || colId;
    return _objectSpread(_objectSpread(_objectSpread({}, fieldName !== null ? getColumnFromField(fields.find(function (it) {
      return it.name === fieldName;
    }) || null) : null), otherProps), {}, {
      id: colId || (isString(column) ? column : null) || null
    });
  }).filter(function (it) {
    return it !== null;
  }) : [];
  return newColumns;
};

var getComponentFromName = function getComponentFromName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (components === null || name === null) {
    return defaultComponent;
  }
  var pascalName = pascalCase(name);
  // console.log(name, pascalName, components);
  var component = components[pascalName] || components[name] || defaultComponent;
  if (!component) {
    console.warn('Could not find component from name', name, pascalName, components);
  }
  return component;
};

var getDefinitionFromId = function getDefinitionFromId() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (items === null || id === null || isArray(items) && items.length === 0) {
    return defaultObject;
  }
  var pascalId = pascalCase(id);
  return items.find(function (i) {
    return i.id === pascalId;
  }) || items.find(function (i) {
    return i.id === id;
  }) || defaultObject;
};

var getDisplayName = function getDisplayName(_ref) {
  var _ref$displayName = _ref.displayName,
    displayName = _ref$displayName === void 0 ? null : _ref$displayName,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name;
  return displayName || name || 'Component';
};

var _getFieldByName = function getFieldByName(fields, name) {
  return fields.reduce(function (foundField, it) {
    if (foundField !== null) {
      return foundField;
    }
    var _it$name = it.name,
      fieldName = _it$name === void 0 ? null : _it$name,
      _it$fields = it.fields,
      subFields = _it$fields === void 0 ? [] : _it$fields;
    if (name !== null && fieldName === name) {
      return it;
    }
    return _getFieldByName(subFields, name);
  }, null);
};

var getFieldFromPath = function getFieldFromPath(path, fields, fieldManager) {
  return (isArray(path) ? path : [path]).reduce(function (foundField, key) {
    if (foundField === null) {
      return null;
    }
    var _foundField$type = foundField.type,
      type = _foundField$type === void 0 ? null : _foundField$type,
      _foundField$fields = foundField.fields,
      fieldFields = _foundField$fields === void 0 ? null : _foundField$fields,
      _foundField$field = foundField.field,
      field = _foundField$field === void 0 ? null : _foundField$field;
    var finalType = field !== null ? field.type || type : type;
    var _ref = finalType !== null ? fieldManager.getDefinition(finalType) : foundField,
      _ref$fields = _ref.fields,
      subFields = _ref$fields === void 0 ? null : _ref$fields,
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? null : _ref$settings,
      _ref$itemsField = _ref.itemsField,
      itemsField = _ref$itemsField === void 0 ? null : _ref$itemsField;
    if (itemsField !== null && key.match(/^[0-9]+$/)) {
      return _objectSpread(_objectSpread({}, itemsField), {}, {
        name: path.join('/'),
        listItems: true
      });
    }
    return _getFieldByName([].concat(_toConsumableArray(fieldFields || []), _toConsumableArray(subFields || []), _toConsumableArray(settings || [])), key);
  }, {
    fields: fields
  });
};

var getFileName = function getFileName() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (url === null || typeof url.match === 'undefined') {
    return null;
  }
  return url.match(/([^/]+)(\?.*)?$/)[1] || url;
};

var getPathValue = function getPathValue(it, path) {
  var value = get(it, path, null);
  return value !== null && isObject(value) ? Object.values(value).reduce(function (foundValue, val) {
    return foundValue !== null ? foundValue : val;
  }, null) : value;
};

var getSelectOptions = function getSelectOptions(options) {
  return options.map(function (it) {
    if (isObject(it)) {
      var _it$label = it.label,
        label = _it$label === void 0 ? null : _it$label,
        value = it.value;
      if (label === null) {
        return {
          value: value,
          label: capitalize("".concat(value))
        };
      }
      return {
        value: value,
        label: /*#__PURE__*/isValidElement(label) ? label : "".concat(label)
      };
    }
    return {
      value: it,
      label: capitalize("".concat(it))
    };
  });
};

var isMessage = function isMessage(message) {
  return isObject(message) && typeof message.defaultMessage !== 'undefined';
};

/**
 * Locale loader
 */
var loaders = {};
var events = new EventEmitter();
function loadPackage(name, loader) {
  if (typeof loaders[name] === 'undefined') {
    loaders[name] = {
      loader: loader().then(function (response) {
        loaders[name].loader = null;
        loaders[name].loaded = true;
        loaders[name].resource = response;
        events.emit("loaded:".concat(name), response);
        return response;
      }),
      loaded: false,
      resource: null
    };
  }
  return new Promise(function (resolve) {
    var _ref = loaders[name] || {},
      _ref$loaded = _ref.loaded,
      loaded = _ref$loaded === void 0 ? false : _ref$loaded,
      resource = _ref.resource;
    if (loaded === true) {
      resolve(resource);
    } else {
      events.once("loaded:".concat(name), function (response) {
        resolve(response);
      });
    }
  });
}

function filterNullItems(items) {
  return isArray(items) ? items.filter(function (it) {
    return it !== null;
  }) : items;
}
function getItemsArray(items) {
  return (items !== null && isArray(items) ? items.filter(function (it) {
    return it !== null;
  }) : [items]).filter(function (it) {
    return it !== null;
  });
}
function selectItem(item, selectedItems, onSelectionChange) {
  var multipleSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _ref = item || {},
    _ref$id = _ref.id,
    itemId = _ref$id === void 0 ? null : _ref$id;
  var selectedItemsArray = getItemsArray(selectedItems);
  var oldItem = selectedItemsArray.find(function (_ref2) {
    var id = _ref2.id;
    return id === itemId;
  }) || null;
  var newItems = [];
  if (oldItem === null) {
    newItems = selectedItems !== null && multipleSelection ? [].concat(_toConsumableArray(selectedItemsArray), [item]) : [item];
  } else {
    newItems = selectedItemsArray.filter(function (_ref3) {
      var id = _ref3.id;
      return id !== itemId;
    });
  }
  if (onSelectionChange !== null) {
    var _ref4 = newItems || [],
      _ref5 = _slicedToArray(_ref4, 1),
      _ref5$ = _ref5[0],
      firstItem = _ref5$ === void 0 ? null : _ref5$;
    var value = multipleSelection ? filterNullItems(newItems) : firstItem;
    onSelectionChange(value);
  }
}
function selectPage(pageSelected, items, selectedItems, onSelectionChange) {
  var nextItems = [];
  if (!pageSelected) {
    nextItems = uniqBy([].concat(_toConsumableArray(items || []), _toConsumableArray(selectedItems || [])), function () {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref6$id = _ref6.id,
        id = _ref6$id === void 0 ? null : _ref6$id;
      return id;
    });
  } else {
    var ids = (items || []).map(function () {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$id = _ref7.id,
        id = _ref7$id === void 0 ? null : _ref7$id;
      return id;
    }).filter(function (id) {
      return id !== null;
    });
    nextItems = uniqBy((selectedItems || []).filter(function (it) {
      var _ref8 = it || {},
        _ref8$id = _ref8.id,
        id = _ref8$id === void 0 ? null : _ref8$id;
      return ids.indexOf(id) === -1;
    }), function () {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref9$id = _ref9.id,
        id = _ref9$id === void 0 ? null : _ref9$id;
      return id;
    });
  }
  var finalNextItems = nextItems;
  if (onSelectionChange !== null) {
    onSelectionChange(finalNextItems);
  }
}

var _setValue = function setValue(value, keyParts, fieldValue) {
  var key = keyParts.shift();
  var isArray = key.match(/^[0-9]+$/) !== null;
  if (value !== null || fieldValue !== null) {
    if (isArray) {
      var index = parseInt(key, 10);
      var newArrayValue = fieldValue !== null ? [].concat(_toConsumableArray(value.slice(0, index)), [keyParts.length > 0 ? _setValue(value !== null ? value[index] || null : null, keyParts, fieldValue) : fieldValue], _toConsumableArray(value.slice(index + 1))) : [].concat(_toConsumableArray(value.slice(0, index)), _toConsumableArray(value.slice(index + 1)));
      return newArrayValue.length > 0 ? newArrayValue : null;
    }
    return _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, key, keyParts.length > 0 ? _setValue(value !== null ? value[key] || null : null, keyParts, fieldValue) : fieldValue));
  }
  return null;
};

var slug = function slug(str) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var toSlug;
  if (separator === '-') {
    toSlug = kebabCase(str);
  } else {
    toSlug = snakeCase$1(str);
  }
  return slugify(toSlug, {
    lower: true
  });
};

var _validateFields = function validateFields(fields, value) {
  return fields.reduce(function (acc, field) {
    if (acc === true) {
      if (field.type === 'fields' && field.fields) {
        return _validateFields(field.fields, value);
      }
      var val = value && value[field.name] ? value[field.name] : false;
      return !(field.required && !val);
    }
    return acc;
  }, true);
};

export { checkClickable, convertStyleToString, copyToClipboard, createNullableOnChange, createUseEvent, _flattenComponents as flattenComponents, formatDuration, getColumnsWithFields, getComponent, getComponentFromName, getDefinitionFromId, getDisplayName, _getFieldByName as getFieldByName, getFieldFromPath, getFileName, getPathValue, getSelectOptions, isMessage, loadPackage, selectItem, selectPage, _setValue as setFieldValue, slug, _validateFields as validateFields };
